import { render, staticRenderFns } from "./UsersData.vue?vue&type=template&id=4b494012"
import script from "./UsersData.vue?vue&type=script&lang=js"
export * from "./UsersData.vue?vue&type=script&lang=js"
import style0 from "./UsersData.vue?vue&type=style&index=0&id=4b494012&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports